export const TRAINER_CALENDAR_START_TIME = '06:00:00'
export const TRAINER_CALENDAR_END_TIME = '22:00:00'
export const TRAINER_CALENDAR_SLOT_DURATION = '00:15:00'
export const TRAINER_CALENDAR_DEFAULT_SCROLL_TIME = '08:00:00'
export const TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const
export const DEFAULT_TABLE_PAGE_SIZE = 100
